import { appConfig } from 'config/app';
import { ITipCalculatorRequest, ITipCalculatorResult } from 'types';
import { ApiClient } from './ApiClient';

export const TipCalculator = {
  shareCalculation: (body: ITipCalculatorRequest) => ApiClient.post<ITipCalculatorResult>(`${appConfig.API_BASE_URL}/v1/tip/share/calculator${body.segmentId ? `?segment_id=${body.segmentId}` : ''}`, body),
};
